import { DotsCheckbox } from "dots-ui/dotsCheckbox";
import { FormikProps } from "formik";
import { useCallback, useContext } from "react";
import { IBlankMediaTypeCommonData } from "../../../../../models";
import { AvisContext } from "../../../../shared/context";
import classNames from "classnames";

interface INoDealCheckboxProps {
  bag: FormikProps<IBlankMediaTypeCommonData>;
  sectionsVisible: boolean | undefined;
  textToDisplayKey: string;
  noDealAccepted: boolean;
  setNoDealAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean | undefined;
  disabled?: boolean;
}

export function NoDealCheckbox(props: Readonly<INoDealCheckboxProps>) {
  const {
    bag,
    sectionsVisible,
    textToDisplayKey,
    noDealAccepted,
    setNoDealAccepted,
    loading,
    disabled,
  } = props;
  const { res, getText } = useContext(AvisContext);

  const handleDealNotOccuredPortal = useCallback(
    (_: any, value: boolean) => {
      if (!value) {
        setNoDealAccepted(false);
      }
    },
    [setNoDealAccepted],
  );
  const classNameApprove = classNames("row", "approve-not-occured");
  return (
    sectionsVisible && (
      <>
        <div className="row">
          <DotsCheckbox<IBlankMediaTypeCommonData>
            checkboxLabel={res("blankMedia_Application_label_DealNotOccured")}
            bag={bag}
            bagField="dealNotOccuredPortal"
            disabled={disabled || loading || disabled}
            onChange={handleDealNotOccuredPortal}
          />
        </div>
        {bag.values.dealNotOccuredPortal && (
          <div className={classNameApprove}>
            <DotsCheckbox
              disabled={!bag.values.dealNotOccuredPortal || loading || disabled}
              checked={noDealAccepted}
              onChange={() => setNoDealAccepted(!noDealAccepted)}
            />
            <div className="approve-not-occured-text">
              <i className="dots-asterisk fas fa-asterisk"></i>
              {getText(textToDisplayKey)}
            </div>
          </div>
        )}
      </>
    )
  );
}
